'use client';

import React from 'react';
import { TrendingDown, TrendingUp, Home, Clock } from 'lucide-react';

interface Pattern {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export const PatternGrid: React.FC = () => {
  const patterns: Pattern[] = [
    {
      icon: <TrendingDown className="w-6 h-6 text-blue-500" />,
      title: '"I only do refinances"',
      description: "Your Paid Ads Only might look decent - refinances close faster and you see revenue quickly. But your Hybrid System won't show the full multiplier effect because you can't activate agent partnerships without purchase leads. You're trading long-term compound growth for short-term cash flow."
    },
    {
      icon: <TrendingUp className="w-6 h-6 text-green-500" />,
      title: '"I\'m 100% purchase focused"',
      description: "With Paid Ads Only, your timeline will look brutal for the first 6+ months - almost no revenue while expenses mount. This is why most quit. But with the Hybrid System, agent partnerships start producing immediately, offsetting that slow purchase timeline. By Month 12 and beyond, the compound effect of all multipliers creates exponential growth. This is playing the long game - but you need the Hybrid System to survive getting there."
    },
    {
      icon: <Home className="w-6 h-6 text-purple-500" />,
      title: '"My market is expensive"',
      description: "Adjust your Average Commission to reflect your market's loan sizes. Higher-priced markets naturally generate higher commissions—an $800K California loan at 1% earns $8,000 vs. $2,000 on a $200K Ohio loan. Your Cost Per Funded Loan stays the same, but your ROI multiplies with each high-value loan."
    },
    {
      icon: <Clock className="w-6 h-6 text-amber-500" />,
      title: '"I can\'t wait 12 months"',
      description: "Then you need refinance leads for immediate cash flow while building your purchase pipeline for long-term growth. Model a 70/30 or 60/40 mix. This balances immediate returns with future compound growth."
    }
  ];

  return (
    <div className="my-12">
      <h2 className="text-3xl lg:text-4xl font-bold text-neutral-900 mb-8">
        Common Patterns and What They Mean
      </h2>
      <div className="grid grid-cols-1 gap-6">
        {patterns.map((pattern, index) => (
          <div key={index} className="bg-white rounded-lg p-6 border border-neutral-200 hover:border-neutral-300 transition-colors">
            <div className="flex items-start">
              <div className="flex-shrink-0 mr-4 mt-1">
                <div className="w-12 h-12 rounded-lg bg-neutral-100 flex items-center justify-center">
                  {pattern.icon}
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-neutral-900 mb-2">
                  Pattern: {pattern.title}
                </h3>
                <p className="text-neutral-700 leading-relaxed">
                  {pattern.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
